import React from 'react';
import { Container, Alert } from 'react-bootstrap';
import { PageLoader } from '../../Components/LoadingSpinner';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import TodosList from '../Todos/TodosList';
import './ProfilePage.css';

const MyTodosPage: React.FC = () => {
    const [user, loading, error] = useAuthState(auth);

    // Set document title
    useDocumentTitle('Mina att göra');

    if (loading) {
        return (
            <div className="profile-page">
                <PageLoader />
            </div>
        );
    }

    if (error) {
        return (
            <div className="profile-page">
                <Container className="profile-page-container">
                    <Alert variant="danger">
                        <Alert.Heading>Fel vid laddning</Alert.Heading>
                        <p>{error.message}</p>
                    </Alert>
                </Container>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="profile-page">
                <Container className="profile-page-container">
                    <Alert variant="warning">
                        <Alert.Heading>Inte inloggad</Alert.Heading>
                        <p>Du måste vara inloggad för att komma åt denna sida.</p>
                    </Alert>
                </Container>
            </div>
        );
    }

    return (
        <div className="profile-page">
            <Container className="profile-page-container" style={{ maxWidth: '800px' }}>
                <TodosList
                    userId={user.uid}
                    showHeader={true}
                    headerTitle="Mina personliga att göra"
                    headerDescription="Dessa uppgifter är endast synliga för dig."
                />
            </Container>
        </div>
    );
};

export default MyTodosPage;
